import { ContextualMenuItemType, mergeStyles } from '@fluentui/react';
import { SensitivityIconType } from './../SensitivityIcon';
/**
 * getSensitivityContextMenuItems generates the hierarchical menu props required by Fluent UIs
 * from the flat array of sensitivity labels.
 * @param appliedSensitivityLabel The currently applied label. Used to populate the isChecked flag.
 * @param sensitivityLabels Information protection label information which includes the
 * flat list of available sensitivity labels
 * @param onItemClick The handler when a menu item is clicked
 * @param onSubMenuItemRender Custom component to use for rendering individual menu items.
 * @returns an array of contextual menu items which can be used to power Fluent UIs
 */ export function getSensitivityContextMenuItems(appliedSensitivityLabel, sensitivityLabels, onItemClick, onSubMenuItemRender, menuStyles, stylingProviderThemeProperties, moreInfoLink, moreInfoString) {
    const contextMenu = {};
    sensitivityLabels.forEach((label)=>{
        // Ignore if the label is not active
        if (!label.isActive) {
            return;
        }
        const menuItem = getContextualMenuFromSensitivityLabel(label, appliedSensitivityLabel, onItemClick);
        // If parent exists then add the menu item to the subMenus of the parent.
        if (label.parent) {
            if (!contextMenu.hasOwnProperty(label.parent.id)) {
                contextMenu[label.parent.id] = getContextualMenuFromSensitivityLabel(label.parent, appliedSensitivityLabel, onItemClick);
            }
            const parentMenu = contextMenu[label.parent.id];
            // create subMenuProps if they dont exist or else add to existing collection.
            if (parentMenu.subMenuProps) {
                parentMenu.subMenuProps.items.push(menuItem);
            } else {
                parentMenu.subMenuProps = {
                    items: [
                        menuItem
                    ],
                    contextualMenuItemAs: onSubMenuItemRender,
                    styles: menuStyles,
                    calloutProps: {
                        className: mergeStyles(stylingProviderThemeProperties)
                    }
                };
                parentMenu.canCheck = false;
                parentMenu['isChecked'] = undefined;
            }
        // If the current label is already inserted (as a parent previously) then skip
        } else if (!contextMenu.hasOwnProperty(label.id)) {
            contextMenu[label.id] = menuItem;
        }
    });
    if (moreInfoLink && moreInfoString) {
        contextMenu['divider'] = {
            key: 'divider',
            itemType: ContextualMenuItemType.Divider
        };
        contextMenu['moreInfo'] = {
            key: 'moreInfo',
            hasIcon: false,
            text: moreInfoString,
            onClick: ()=>{
                window.open(moreInfoLink);
            }
        };
    }
    return Object.keys(contextMenu).map((id)=>contextMenu[id]);
}
function getContextualMenuFromSensitivityLabel(label, appliedSensitivityLabel, onItemClick) {
    return {
        key: label.id,
        text: label.name,
        canCheck: true,
        isChecked: label.id === appliedSensitivityLabel?.sensitivityLabelId,
        onClick: onItemClick,
        sensitivityIconType: label.hasProtection ? SensitivityIconType.TagProtectedSmall : SensitivityIconType.TagSmall
    };
}
